import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  total_products: null,
  normal_price_at_Risk: null,
  normal_price_at_margin: null,
  sale_price_at_risk: null,
  sale_price_at_margin: null,
  normal_price_product_requiring_approval: null,
  sale_price_product_requiring_approval: null,
  total_buyers: null,
  total_admins: null,
  total_products_price_doesnot_feed: null,
  last_currency_deviation_captured: null,
  last_IBS_update: null,
}

const Dashboardskeltonloader = createSlice({
  name: "Dashboard_skelton_loader",
  initialState,
  reducers: {

    skeltonLoader(state, action) {
      Object.assign(state, action.payload)
    },


    clearskeltonLoader() {
      return initialState
    }
  }
})

export default Dashboardskeltonloader.reducer;
export const { skeltonLoader, clearskeltonLoader } = Dashboardskeltonloader.actions;
